// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min";
import {createBrowserHistory} from "history";
import {Route, Router, Switch} from "react-router-dom";
import "./index.css";
import React from "react";
import {Demo} from "./pages/Demo";

const history = createBrowserHistory();

function App() {

    document.title = "Plateforme demo | DAVIPAY";


    return (
        <React.Fragment>
            <div className="App">
                <Router history={history}>
                    <Switch>
                        <Route exact path="/">
                            <Demo/>
                        </Route>
                    </Switch>
                </Router>
            </div>
        </React.Fragment>
    );
}

export default App;
